import { useApi } from './useApi';
import { url } from '../../utils/confserveur';

/**
 * Historique des 50 derniers gains d'XP de l'élève (GET /transactions-xp/), antéchronologique.
 *
 * @param {*} refresh - force un re-fetch
 * @param {boolean} enabled - false → désactivé (non élève)
 * @returns {{data, isLoading, isError}}
 */
export const useTransactionsXp = (refresh, enabled = true) =>
  useApi(`${url}transactions-xp/`, [], refresh, enabled ? null : 'not-enabled');
